/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Loading_EventsInputs */

const th_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังโหลดรายการแข่งขัน…`)
};

const en_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading events…`)
};

const ja_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大会を読み込んでいます…`)
};

const zh_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载赛事…`)
};

const es_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando eventos…`)
};

const pt_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando eventos…`)
};

const id_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat acara…`)
};

const fr_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des événements…`)
};

const tl_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nilo-load ang mga event…`)
};

const vi_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tải sự kiện…`)
};

const ko_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트를 불러오는 중…`)
};

const de_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events werden geladen…`)
};

const ru_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загружаем события…`)
};

const tr_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlikler yükleniyor…`)
};

const it_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento eventi…`)
};

const pl_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wczytywanie wydarzeń…`)
};

const uk_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Завантажуємо події…`)
};

const hi_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयोजन लोड हो रहे हैं…`)
};

const ar_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جارٍ تحميل الفعاليات…`)
};

const ms_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memuat acara…`)
};

const bn_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আয়োজন লোড হচ্ছে…`)
};

const zh_tw2_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入賽事…`)
};

const zh_hk2_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在載入賽事…`)
};

const ur_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ایونٹ لوڈ ہو رہے ہیں…`)
};

const fa_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`در حال بارگذاری رویدادها…`)
};

const sw_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inapakia matukio…`)
};

const nl_loading_events = /** @type {(inputs: Loading_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenementen laden…`)
};

/**
* | output |
* | --- |
* | "Loading events…" |
*
* @param {Loading_EventsInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const loading_events = /** @type {((inputs?: Loading_EventsInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Loading_EventsInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_loading_events(inputs)
	if (locale === "ja") return ja_loading_events(inputs)
	if (locale === "zh") return zh_loading_events(inputs)
	if (locale === "es") return es_loading_events(inputs)
	if (locale === "pt") return pt_loading_events(inputs)
	if (locale === "id") return id_loading_events(inputs)
	if (locale === "fr") return fr_loading_events(inputs)
	if (locale === "tl") return tl_loading_events(inputs)
	if (locale === "vi") return vi_loading_events(inputs)
	if (locale === "ko") return ko_loading_events(inputs)
	if (locale === "de") return de_loading_events(inputs)
	if (locale === "ru") return ru_loading_events(inputs)
	if (locale === "tr") return tr_loading_events(inputs)
	if (locale === "it") return it_loading_events(inputs)
	if (locale === "pl") return pl_loading_events(inputs)
	if (locale === "uk") return uk_loading_events(inputs)
	if (locale === "hi") return hi_loading_events(inputs)
	if (locale === "ar") return ar_loading_events(inputs)
	if (locale === "ms") return ms_loading_events(inputs)
	if (locale === "bn") return bn_loading_events(inputs)
	if (locale === "zh-TW") return zh_tw2_loading_events(inputs)
	if (locale === "zh-HK") return zh_hk2_loading_events(inputs)
	if (locale === "ur") return ur_loading_events(inputs)
	if (locale === "fa") return fa_loading_events(inputs)
	if (locale === "sw") return sw_loading_events(inputs)
	if (locale === "nl") return nl_loading_events(inputs)
	return en_loading_events(inputs)
});